@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../layout";

.contactInfo {
    text-align: center;
}

.downloads {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 25px;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: 1fr;
    }
}

.download {
    text-align: center;
}

.downloadPreview {
    background: var(--color-snowbank);
    padding: 25px;
    text-align: center;
    min-height: 310px;
    margin-bottom: 1rem;
    text-transform: uppercase;

    h3 {
        margin-bottom: 1rem;
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;

        svg {
            width: 1.5em;
            fill: var(--color-lobster);
        }
    }
}

.downloadBtn {
    composes: button from "../../styles/buttons.module.scss";
}

.visuallyHidden {
    display: block;
    height: 0;
    width: 0;
    visibility: hidden;
}
